const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import PlayerListView from "./playerlist_view";
import EventManager from "../../../../manager/event_manager";
import AppData from "../../../public/const/app_data";
@ccclass
@moduleInit("PlayerListModule")
export default class PlayerListModule extends ModuleBase<PlayerListView, null>  {

    constructor() {
        super()
        if (AppData.gameName == "TM_HHDZ") {
            this.windowPrefabResPath = 'package/honhei/players_table_honhei'

        } else if (AppData.gameName == "TM_LHD") {
            this.windowPrefabResPath = 'package/longhudou/players_table';
        }
        else{
            this.windowPrefabResPath = 'package/longhudou/players_table';
        }
        
        this.viewType = PlayerListView;
        this.needViewMask = true
        this.needAnim = true
    }

    onShow(intentData){
        super.onShow(intentData);
        this.view.updateShow(intentData)
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            default:
                break;
        }
    }




}